// removed by extract-text-webpack-plugin
module.exports = {"component":"_3Hq_zip7W5FTQo3NynHelE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FormElements/Spacer/Spacer.css
// module id = 1379
// module chunks = 0